import React from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import Parse from 'parse';
import _ from 'lodash';
import Swal from 'sweetalert2';
import FreezeColumn from './FreezeColumn';

import questions from './questions';

const Answers = Parse.Object.extend('Answers');
const questionsKeys = questions.map((_, index) => `question-${index}`);
const pavo = ['p', 'a', 'v', 'o', 'p', 'a', 'v', 'o'];
const schema = yup.object(
  Object.assign(
    {},
    {
      nameInterviewer: yup.string().required(),
      nameCandidate: yup.string().required(),
      comments: yup.string().required()
    },
    ...questionsKeys.map(key => ({ [key]: yup.string().required() }))
  )
);

const onSubmit = async (answerValues, actions) => {
  const newAnswer = new Answers();
  const { nameInterviewer, nameCandidate, comments, course } = answerValues;
  const answers = Object.assign(
    {},
    ...questionsKeys.map(key => ({ [key]: +answerValues[key] }))
  );

  try {
    const response = await newAnswer.save({
      nameInterviewer,
      nameCandidate,
      comments,
      course,
      answers
    });
    const result = response && response.get('result');

    Swal.fire({
      title:
        result && result >= 70
          ? "<strong className='aprovado'>Aprovado!</strong>"
          : `<strong className="reprovado">Resultado abaixo da nota de corte</strong>`,
      text:
        result !== undefined
          ? `A aderência calculada para o candidato ${nameCandidate} foi de ${result}%`
          : 'Os dados de aderência estarão disponíveis em breve!',
      footer:
        (!answers['question-2'] &&
          'Atenção: Candidato precisa desenvolver "Aprendizado Contínuo".') ||
        '',
      icon: 'success',
      onClose: () => {
        window.location.reload();
      }
    });
  } catch (err) {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: 'Tente novamente mais tarde',
      icon: 'error',
      onClose: () => {
        window.location.reload();
      }
    });
  }

  actions.setSubmitting(false);
  actions.resetForm();
};

const ProfileScript = ({ courses = [], currentUser, currentInstitution }) => {
  const coursesUniqByLabel = _.uniqBy(courses, 'label');
  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={Object.assign(
        {},
        {
          nameInterviewer: currentUser.name,
          nameCandidate: '',
          comments: ''
        },
        ...questionsKeys.map(key => ({ [key]: '' }))
      )}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Row className="border-between">
          <FreezeColumn
            title="Processo Seletivo"
            currentInstitution={currentInstitution}
          />
          <Col xs={12} md={9} className="scrollable-column">
            <Form
              noValidate
              onSubmit={handleSubmit}
              style={{ paddingBottom: '20px' }}
            >
              <Form.Group controlId="formNameInterviewer">
                <Form.Label>Nome do Entrevistador(a)</Form.Label>
                <Form.Control
                  type="text"
                  name="nameInterviewer"
                  value={values.nameInterviewer}
                  disabled
                />
              </Form.Group>

              <Form.Group controlId="formNameCandidate">
                <Form.Label>Nome do Candidato(a)</Form.Label>
                <Form.Control
                  type="text"
                  name="nameCandidate"
                  value={values.nameCandidate}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="course">
                <Form.Label>Selecione o curso</Form.Label>
                <Form.Control as="select" onChange={handleChange}>
                  <option>Escolher</option>
                  {_.map(coursesUniqByLabel, course => (
                    <option value={course.id} key={course.id}>
                      {course.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {questions.map((question, questionIndex) => (
                <Card className="mb-3" body key={questionIndex}>
                  <Form.Group
                    controlId={`formQuestion-${questionIndex}`}
                    className="mb-4"
                  >
                    <Form.Label>{`${questionIndex + 1}${
                      pavo[questionIndex]
                    } - ${question.label}`}</Form.Label>
                    <div className="mb-3">
                      <fieldset>
                        {question.answers.map((answer, answerIndex) => (
                          <Form.Check
                            inline={question.layout === 'inline'}
                            label={answer.label}
                            type="radio"
                            id={`inline-radio-${questionIndex}-${answerIndex}`}
                            name={`question-${questionIndex}`}
                            key={answerIndex}
                            value={answer.value}
                            onChange={handleChange}
                          />
                        ))}
                      </fieldset>
                    </div>
                  </Form.Group>
                </Card>
              ))}

              <Form.Group controlId="formComments">
                <Form.Label>Comentários</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="3"
                  name="comments"
                  value={values.comments}
                  onChange={handleChange}
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                Enviar
              </Button>
            </Form>
          </Col>
        </Row>
      )}
    </Formik>
  );
};

export default ProfileScript;
